import { combineReducers } from "redux-immutable";
import status from "./status/reducer";
import download from "./download/reducer";
import upload from "./upload/reducer";

const dataToolsReducer = combineReducers({
  status,
  download,
  upload
});

export default dataToolsReducer;
